import * as Yup from 'yup';
import {
  ATTRIBUTES,
  IMPRESSION_TYPE_METHODS,
  SCAN_SUBMISSION_METHODS,
  SCANNERS,
  PRODUCTS_LIST_METHODS,
  PRODUCTS_LIST_VALUES
} from './constants';
import patterns from '../../constants/patterns';
import { REQUEST_ASSIGNMENT_IN_OFFICE } from '../../constants';

const schema = {
  first_name: Yup.string()
    .required('Required')
    .matches(
      patterns.name,
      'Name may only contain letters (first letter uppercase), spaces, points, brackets, and apostrophes.'
    ),
  last_name: Yup.string()
    .required('Required')
    .matches(
      patterns.name,
      'Name may only contain letters (first letter uppercase), spaces, points, brackets, and apostrophes.'
    ),
  case_number_text: Yup.string()
    .nullable()
    .matches(
      patterns.case_number,
      'Case number may only contain letters, spaces, points, brackets, and apostrophes.'
    ),
  impression_date: Yup.date().required('Required'),
  // submission_completed_by: Yup.number().required('Required'),
  rush_case: Yup.boolean(),
  rush_case_authorized_by: Yup.string().when('rush_case', {
    is: val => val === true,
    then: Yup.string().required('Required')
  }),
  impression_type: Yup.number().required('Required'),
  scan_submission_type: Yup.number().when('impression_type', {
    is: val => Number(val) === IMPRESSION_TYPE_METHODS.INTRA_ORAL_SCANS,
    then: Yup.number().required('Required')
  }),
  // nullable doesn't work on number, probably needs to update Yup version
  // scanner_type: Yup.number()
  //   .nullable()
  //   .when('scan_submission_type', {
  //     is: value => value === SCAN_SUBMISSION_METHODS.SCANNER,
  //     then: () => {
  //       return Yup.number().nullable();
  //     }
  //   })
  //   .transform((_, v) => (v === '' ? null : v)),
  // jaws_id: Yup.number().required('Required'),
  custom_scanner_type_name: Yup.string().when('scanner_type', {
    is: val => Number(val) === SCANNERS.OTHER,
    then: Yup.string().required('Required')
  }),
  stl_files: Yup.array().when(['impression_type', 'scan_submission_type'], {
    is: (impressionType, scanSubmissionType) => {
      return (
        Number(impressionType) === IMPRESSION_TYPE_METHODS.INTRA_ORAL_SCANS &&
        Number(scanSubmissionType) === SCAN_SUBMISSION_METHODS.UPLOAD
      );
    },
    then: Yup.array()
      .of(
        Yup.object().shape({
          file_path: Yup.string().required('Required'),
          name: Yup.string().required('Required')
        })
      )
      .required('Required')
      .min(1),
    otherwise: validationSchema => validationSchema.nullable()
  }),
  rx_intraoral_photos: Yup.array().of(
    Yup.object().shape({
      file_path: Yup.string().required('Required'),
      name: Yup.string().required('Required')
    })
  ),
  boxes: Yup.number().when('box_size', {
    is: val => !!val,
    then: Yup.number().required('Required')
  }),
  box_size: Yup.string().when('boxes', {
    is: val => !!val,
    then: Yup.string().required('Required')
  }),
  products_list: Yup.number().test(
    'requires-product-selection',
    'A Product / Finish selection is required',
    function(value) {
      const impressionType = Number(this.parent.impression_type);
      const productsList = Number(value) || 0;

      if (impressionType === IMPRESSION_TYPE_METHODS.INTRA_ORAL_SCANS) {
        const intraOralProducts =
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.CLEANUP] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.CLEANUP_BASE] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.SEMI_FINISH] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.DIGITAL_STORAGE];

        if ((productsList & intraOralProducts) === 0) return false;

        return true;
      }

      if (impressionType === IMPRESSION_TYPE_METHODS.STONE_MODEL) {
        const stoneModelProducts =
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.FULL_DIGITAL_MODEL] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.SEMI_FINISH_DIGITAL_MODEL] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.ROUGH_DIGITAL_MODEL] |
          PRODUCTS_LIST_VALUES[PRODUCTS_LIST_METHODS.DIGITAL_STORAGE_ONLY];

        return (productsList & stoneModelProducts) > 0;
      }

      return true;
    }
  )
  /*ios_files: Yup.array()
    .of(
      Yup.object().shape({
        file_path: Yup.string().required('Required'),
        name: Yup.string().required('Required')
      })
    )
    .required('Required')
    .min(1),
  export_type: Yup.number().required(),
  print_assignment: Yup.number().required(),
  insert_brackets_assignment: Yup.number().required(),
  location_id: Yup.number()
    .nullable()
    .when('print_assignment', {
      is: val => val !== ASSIGNMENTS.IN_OFFICE,
      then: Yup.number().required()
    }),
  shipping_method: Yup.string()
    .nullable()
    .when('print_assignment', {
      is: val => val === ASSIGNMENTS.ORTHOSELECT,
      then: Yup.string().required()
    }),
  root_integration: Yup.boolean().required(),
  bonding_date: Yup.date().nullable()*/
};

export const createValidationSchema = (attributes = [], overrideOptions = {}) => {
  const options = { requireBracketLibraries: false, requireDoctor: false, ...overrideOptions };
  const additionalValidation = {};
  if (options.requireBracketLibraries) {
    additionalValidation.bracket_libraries = Yup.array().when(
      ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT,
      {
        is: assignment => assignment === REQUEST_ASSIGNMENT_IN_OFFICE,
        then: validationSchema => validationSchema.nullable(),
        otherwise: validationSchema => validationSchema.required().min(1)
      }
    );
  }
  if (options.requireDoctor) {
    additionalValidation[ATTRIBUTES.DOCTOR] = Yup.number().required('Required');
  }

  if (attributes.length === 0) {
    return Yup.object().shape({ ...schema, ...additionalValidation }, ['box_size', 'boxes']);
  }
  const only = {};
  attributes.forEach(attribute => {
    only[attribute] = schema[attribute];
  });
  return Yup.object().shape(only, ['box_size', 'boxes']);
};
